import { render, staticRenderFns } from "./ComplainTypeListFilter.vue?vue&type=template&id=7b796ee1&scoped=true&"
import script from "./ComplainTypeListFilter.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b796ee1",
  null
  
)

export default component.exports